import AttachmentsUploadModule from './attachments-upload.module'

export default AttachmentsUploadModule
